/**
 * This function gets called by the plugin when it is registered. Resolve
 * all the plugins enabledregistered instances. Store the package so that
 * it can be configured in the correct order when all mandatory plugins
 * have registered.
 *
 * @param {object} pluginPackage - The plugin object package
 * @param {array} enabledPlugins - All enabled plugins
 * @param {function} loadedCallback
 */
function registerPlugin(pluginPackage, enabledPlugins, loadedCallback) {
    try {

        _assertPluginPackage(pluginPackage)

        for(const i in enabledPlugins) {
            if (enabledPlugins[i].config.name === pluginPackage.name) {
                enabledPlugins[i].package = pluginPackage
                enabledPlugins[i].resolve()
            }
        }

        loadedCallback(pluginPackage.name, pluginPackage)
    }
    catch(ex) {
        const name = pluginPackage && pluginPackage.name ? pluginPackage.name : 'unknown'

        for(const i in enabledPlugins) {
            if (enabledPlugins[i].config.name === name) {
                // Always resolve, we'll check if it is mandatory later
                // when configuring the packages (which is not registered now)
                enabledPlugins[i].resolve()
            }
        }

        loadedCallback(name)
    }
}

/**
 * Assert that plugin Package has `name` and `configure` properties
 *
 * @param pluginPackage
 * @private
 */
function _assertPluginPackage(pluginPackage) {
    if (!pluginPackage || !pluginPackage.name || !pluginPackage.configure) {
        throw new Error('Plugin package does not conform to package standard')
    }
}

export {registerPlugin}
